import { useBackend } from "../../services";

export const useGetBundleProducts = () => {
  const { get } = useBackend();
  const getBundleProducts = () => get("products/bundles");
  return { getBundleProducts };
};
